import styled from 'styled-components';

export const Container = styled.section`
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
`;

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding-inline: 2rem;
  padding-block: 40px;
  background-color: #f5f5f5;
  max-width: 1140px;

  @media (min-width: 600px) {
    padding-inline: 6rem;
  }
`;

export const Title = styled.h2`
  color: var(--secondary-color);
  text-align: center;
  font-size: 40px !important;
  font-style: normal;
  font-weight: 900;
  line-height: normal;

  @media (max-width: 600px) {
    font-size: 36px !important;
  }
`;

export const Description = styled.span`
  color: var(--secondary-color);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 10px;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;

export const SubTitle = styled.h3`
  color: var(--secondary-color);
  text-align: left;
  font-size: 24px !important;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  margin: 22px 0 !important;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;

  @media (max-width: 600px) {
    text-align: center;
    width: 100%;
    font-size: 20px !important;
  }
`;

export const Text = styled.p`
  color: #4b5563;
  line-height: 1.6;
  margin: 0;
  font-size: 16px !important;

  @media (max-width: 600px) {
    font-size: 14px !important;
  }
`;
